export default __webpack_public_path__ + "static/emma-55f9c7706994d4cff86987cd063ecef1.webp";